export default __webpack_public_path__ + "static/media/hot-breakfast.6de12377.webp";